<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  data() {
    return {}
  },
  methods: {
    save() {
      if (this.employee.username) {
        this.saveUserAccount()
          .then((res) => {
            this.saveEmployee()
          })
          .then((res) => {
            this.$message(
              this.$t('app.messages.success.title'),
              this.$t('app.messages.saveSuccess')
            )
            this.returnToList()
          })
          .catch((err) => {
            this.$showApiError(err)
          })
      } else {
        this.saveEmployee()
          .then((res) => {
            this.$message(
              this.$t('app.messages.success.title'),
              this.$t('app.messages.saveSuccess')
            )
            this.returnToList()
          })
          .catch((error) => {
            this.$message(
              this.$t('app.messages.errors.title'),
              this.$t('app.messages.fail')
            )
          })
      }
    },
    saveEmployee() {
      if (this.employee.buyers.length > 0) {
        this.employee.tdocDataAuthorities = this.employee.buyers
          .map((b) => b.text)
          .join(',')
      } else {
        this.employee.tdocDataAuthorities = null
      }
      this.employee.roles = this.userRoles.map((r) => r.roleCode).join()
      return this.$http
        .put(`/employees/${this.employee.id}`, this.employee)
        .then((res) => {
          res.data
        })
        .catch((error) => {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.fail')
          )
        })
    },
    deleteEmployee() {
      return this.$http
        .delete(`/employees/${this.$route.query.id}`)
        .then((res) => {
          return res
        })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          if (this.employee.userAccountId) {
            this.$http
              .delete(
                `/auth-service/auth/remove-user?userId=${
                  this.employee.userAccountId
                }`
              )
              .then((res) => {
                if (res.data.success) {
                  return this.deleteEmployee()
                } else {
                  return Promise.reject(res)
                }
              })
              .then((res) => {
                this.$message('', this.$t('app.messages.removeSuccess'))
                this.returnToList()
              })
              .catch((error) => {
                this.$message(
                  this.$t('app.messages.errors.title'),
                  this.$t('app.messages.fail')
                )
              })
          } else {
            this.deleteEmployee()
              .then((res) => {
                this.$message('', this.$t('app.messages.removeSuccess'))
                this.returnToList()
              })
              .catch((error) => {
                this.$message(
                  this.$t('app.messages.errors.title'),
                  this.$t('app.messages.fail')
                )
              })
          }
        }
      )
    },
    load() {
      this.$http
        .get(`/employees/${this.$route.query.id}`)
        .then((res) => {
          this.employee = res.data
          this.employee.loginRefused = res.data.loginRefused
          this.employee.buyers = res.data.tdocDataAuthorities
            ? res.data.tdocDataAuthorities.split(',').map((a) => {
                return {
                  text: a,
                  value: a.split(':') && a.split(':')[0],
                }
              })
            : []
          this.$http
            .get(`/files/users/${this.employee.email}/files?category=enroll`)
            .then((res) => {
              this.files = res.data
            })
          this.getAllBuyers()
          return this.employee
        })
        .then(() => {
          if (!this.employee.userAccountId) {
            this.userRoles = []
          } else {
            this.userRoles = this.roles.filter((r) => {
              var userRoles = this.employee.roles.split(',')
              return userRoles.indexOf(r.roleCode) > -1
            })
          }
        })
    },
  },
  mounted() {
    this.$refs.rightListDlg.loadRoles().then((res) => {
      this.roles = res
      this.load()
    })
  },
}
</script>
<style>
.btn {
  position: absolute;
  right: 200px;
  top: 0px;
}
</style>
